import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROSE = "#e11d48";

export default function PreinscriptionPowerKickHer() {
  const [info, setInfo] = useState(null);
  const [sessionId, setSessionId] = useState("");
  const promo = new URLSearchParams(window.location.search).get("promo") || "";
  const [form, setForm] = useState({ member_name: "", email: "", phone: "", formule: "evaluation" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [wl, setWl] = useState({ member_name: "", email: "", phone: "" });
  const [wlDone, setWlDone] = useState(false);

  useEffect(() => {
    axios.get(`${API}/powerkick-her/public/info`).then((r) => {
      setInfo(r.data);
      const open = (r.data.sessions || []).filter((s) => !s.full);
      if (open.length) setSessionId(open[0].id);
      else if (r.data.sessions?.length) setSessionId(r.data.sessions[0].id);
    }).catch(() => setInfo({ sessions: [] }));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.member_name.trim()) return;
    if (form.formule === "evaluation") {
      window.location.href = `/cours-essai?program=powerkick-her&src=pkh&name=${encodeURIComponent(form.member_name)}&email=${encodeURIComponent(form.email || "")}&phone=${encodeURIComponent(form.phone || "")}`;
      return;
    }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/powerkick-her/public/preinscription`, { ...form, session_id: sessionId, promo_code: promo });
      if (r.data.checkout_url) { window.location.href = r.data.checkout_url; return; }
      setDone(r.data.message || "Préinscription enregistrée !");
    } catch (err) {
      setDone(err?.response?.data?.detail || "Une erreur est survenue. Réessaie.");
    } finally { setBusy(false); }
  };

  const joinWaitlist = async (e) => {
    e.preventDefault();
    if (!wl.member_name.trim()) return;
    setBusy(true);
    try {
      await axios.post(`${API}/powerkick-her/join-waitlist`, { ...wl, promo_code: promo });
      setWlDone(true);
    } catch { setWlDone(true); } finally { setBusy(false); }
  };

  if (!info) return <div className="min-h-screen bg-black text-zinc-400 flex items-center justify-center">Chargement…</div>;

  const sessions = info.sessions || [];
  const openSessions = sessions.filter((s) => !s.full);
  const prices = info.prices || {};

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="pkh-public-preinscription">
      <div className="max-w-2xl mx-auto px-5 py-12">
        <div className="text-center mb-8">
          <div className="text-5xl mb-2">🥊</div>
          <h1 className="text-3xl md:text-4xl font-black" style={{ color: ROSE }}>PowerKick Her</h1>
          <p className="text-zinc-400 mt-2">{info.subtitle || "Le kickboxing au féminin · 100 % femmes"}</p>
          <p className="text-zinc-500 text-sm mt-3 max-w-md mx-auto">Réserve ta place dans le prochain groupe. Puissance, confiance et communauté 100 % femmes — cours d'essai 19,98 $.</p>
          {promo && false && (
            <div className="mt-4 inline-block border border-rose-500/40 bg-rose-500/10 rounded-full px-4 py-1.5 text-sm" style={{ color: ROSE }} data-testid="pkh-promo-banner">
              🎟️ Offre fondatrice <b>-50 %</b> appliquée (code {promo})
            </div>
          )}
        </div>

        {done ? (
          <div className="border border-emerald-700/50 bg-emerald-900/20 rounded-2xl p-8 text-center" data-testid="pkh-preinscription-done">
            <div className="text-4xl mb-3">✅</div>
            <p className="text-lg text-white">{done}</p>
            <a href="/powerkick-her" className="inline-block mt-5 text-sm text-zinc-400 underline">← Retour à PowerKick Her</a>
          </div>
        ) : openSessions.length > 0 ? (
          <form onSubmit={submit} className="border border-white/10 bg-zinc-900/50 rounded-2xl p-6 space-y-4" data-testid="pkh-preinscription-form">
            <div>
              <label className="text-sm text-zinc-400 mb-2 block">Choisis ton groupe</label>
              <div className="space-y-2">
                {sessions.map((s) => (
                  <label key={s.id} className={`flex items-center gap-3 border rounded-xl p-3 cursor-pointer ${sessionId === s.id ? "border-2" : "border-white/10"} ${s.full ? "opacity-50" : ""}`} style={sessionId === s.id ? { borderColor: ROSE } : {}}>
                    <input type="radio" name="session" disabled={s.full} checked={sessionId === s.id} onChange={() => setSessionId(s.id)} />
                    <div className="flex-1">
                      <div className="font-semibold text-sm">{s.title}</div>
                      <div className="text-xs text-zinc-400">{s.days} · {s.time} · {s.weeks} sem.{s.start_date ? ` · début ${s.start_date}` : ""}</div>
                    </div>
                    <div className="text-xs">{s.full ? <span className="text-amber-400">Complet</span> : <span className="text-emerald-400">{s.spots_left} place(s)</span>}</div>
                  </label>
                ))}
              </div>
            </div>
            <input required value={form.member_name} onChange={(e) => setForm({ ...form, member_name: e.target.value })} placeholder="Ton nom complet" className="w-full bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white" data-testid="pkh-input-name" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Courriel" className="bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white" data-testid="pkh-input-email" />
              <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Téléphone" className="bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white" />
            </div>
            <div>
              <label className="text-sm text-zinc-400 mb-2 block">Formule</label>
              <select value={form.formule} onChange={(e) => setForm({ ...form, formule: e.target.value })} className="w-full bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white" data-testid="pkh-select-formule">
                <option value="evaluation">Cours d'essai — 19,98 $ + taxes</option>
                <option value="reguliere">Session de groupe (12 sem.) · {prices.reguliere} $</option>
              </select>
            </div>
            <button type="submit" disabled={busy} className="w-full py-3.5 rounded-lg text-black font-bold disabled:opacity-50" style={{ background: ROSE }} data-testid="pkh-submit-preinscription">
              {busy ? "Traitement…" : form.formule === "evaluation" ? "Réserver mon cours d'essai (19,98 $)" : "Préinscription & paiement sécurisé"}
            </button>
            <p className="text-xs text-zinc-500 text-center">Paiement sécurisé par Stripe. Sans engagement à long terme.</p>
          </form>
        ) : (
          <div className="border border-white/10 bg-zinc-900/50 rounded-2xl p-6" data-testid="pkh-waitlist-block">
            {wlDone ? (
              <div className="text-center py-6">
                <div className="text-4xl mb-3">💌</div>
                <p className="text-white">Merci ! Tu es sur la liste d'attente PowerKick Her. On te contacte dès l'ouverture du prochain groupe.</p>
              </div>
            ) : (
              <form onSubmit={joinWaitlist} className="space-y-4">
                <p className="text-zinc-300 text-sm">Aucun groupe n'est ouvert pour le moment. Inscris-toi sur la <b>liste d'attente</b> — tu seras la première avertie à l'ouverture !</p>
                <input required value={wl.member_name} onChange={(e) => setWl({ ...wl, member_name: e.target.value })} placeholder="Ton nom complet" className="w-full bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white" data-testid="pkh-wl-name" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <input type="email" value={wl.email} onChange={(e) => setWl({ ...wl, email: e.target.value })} placeholder="Courriel" className="bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white" />
                  <input value={wl.phone} onChange={(e) => setWl({ ...wl, phone: e.target.value })} placeholder="Téléphone" className="bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white" />
                </div>
                <button type="submit" disabled={busy} className="w-full py-3.5 rounded-lg text-black font-bold disabled:opacity-50" style={{ background: ROSE }} data-testid="pkh-wl-submit">
                  {busy ? "…" : "Rejoindre la liste d'attente"}
                </button>
              </form>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
